import { render, staticRenderFns } from "./FigmaAPICallback.vue?vue&type=template&id=22575c60&scoped=true&"
import script from "./FigmaAPICallback.vue?vue&type=script&lang=js&"
export * from "./FigmaAPICallback.vue?vue&type=script&lang=js&"
import style0 from "./FigmaAPICallback.vue?vue&type=style&index=0&id=22575c60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22575c60",
  null
  
)

export default component.exports